import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { environment } from "../../../../environments/environment";
import { catchError, Observable, of } from "rxjs";
import { SiteHoF } from "../models/siteHoF.model";
import { UserHof } from "../models/userHof.model";

@Injectable({
  providedIn: "root",
})
export class HallOfFameService {
  constructor(private http: HttpClient) {}

  /**
   * Récupération du Hall of Fame
   * (meilleurs scores et scores proches)
   */
  getHallOfFame(): Observable<UserHof[]> {
    return this.http.get<UserHof[]>(`${environment.baseUrl}/hof/users`);
  }

  getSiteHallOfFame(): Observable<SiteHoF[]> {
    return this.http
      .get<SiteHoF[]>(`${environment.baseUrl}/admin/hof/sites`)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status === 403) {
            console.error("Access Denied: 403");
          } else {
            console.error("An error occurred:", error.message);
          }
          return of([]);
        }),
      );
  }
}
